// import React, { useState } from "react";
// import Alert from "react-bootstrap/Alert";

// const TrialAlertBanner = ({ showAlertBanner, setShowAlertBanner }) => {
//     return (
//         <div>
//             {" "}
//             <Alert
//                 variant="danger"
//                 onClose={() => setShowAlertBanner(false)}
//                 dismissible
//             >
//                 <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
//                 <p>
//                     Change this and that and try again. Duis mollis, est non commodo
//                     luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.
//                     Cras mattis consectetur purus sit amet fermentum.
//                 </p>
//             </Alert>
//         </div>
//     );
// };

// export default TrialAlertBanner;

import React from "react";
import { Alert, AlertTitle, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./TrialAlertBanner.css"

const TrialAlertBanner = ({ showAlertBanner, setShowAlertBanner, daysLeft }) => {
    if (!showAlertBanner) return null;

    return (
        <Alert
            className="bg-trial-alert-banner"
            severity="warning"
            action={
                <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                    onClick={() => setShowAlertBanner(false)}
                >
                    <CloseIcon fontSize="inherit" />
                </IconButton>
            }
        >
            {/* <AlertTitle>Subscription Expiring Soon</AlertTitle> */}
            {/* Your subscription is about to expire. Renew now to continue enjoying our services. */}
            {daysLeft > 0 ? (
                <>Your trial expires in <strong>{daysLeft} days</strong>. Renew now to continue enjoying our services.</>
            ) : (
                <>Your trial has expired. Please renew to regain access.</>
            )}
        </Alert>
    );
};

export default TrialAlertBanner;
